module.exports = __webpack_public_path__ + "static/lead-generation-ff8924ba5c7e6489b655e1cdaf732618.png";